import React, {
    PropsWithChildren,
    ReactElement,
    useMemo,
    useState,
} from 'react';

import { ISetState } from '../../shared/types/ISetState';

import { IRadioGroupContext, RadioGroupContext } from './RadioGroupContext';

export type IRadioGroupProps = PropsWithChildren<any> & {
    name: string;
    defaultValue: any;
    onChange?: (newValue: any) => void;
};

export function OzRadioGroup (props: IRadioGroupProps): ReactElement {
    const { name, defaultValue, children, onChange }: IRadioGroupProps = props;
    const [selected, setSelected]: [any, ISetState<any>] = useState(defaultValue);

    const context: IRadioGroupContext = useMemo(() => {
        function setSelectedValue (newValue: any): void {
            setSelected(newValue);

            if (onChange) {
                onChange(newValue);
            }
        }

        return {
            name,
            selectedValue: selected,
            setSelectedValue,
        };
    }, [name, selected, setSelected]);

    return (
        <RadioGroupContext.Provider value={context}>{children}</RadioGroupContext.Provider>
    );
}
